import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import { MdClose } from "react-icons/md";
import Typography from "@material-ui/core/Typography";
import TituloDialogs from "components/Dialog/TituloDialogs";
import InfoBody from "components/WidgetDashboard/InfoBody";
import { makeStyles } from "@material-ui/core/styles";
import BatteryInfo from "components/Dispositivo/Info/BatteryInfo";
import MapInfo from "components/Dispositivo/Info/MapInfo";
import FormNuevoUsuario from "components/Usuario/FormNuevoUsuario";
import ActualizarUsuario from "components/Usuario/ActualizarUsuario";
import EditarDispositivo from "components/Dispositivo/EditarDispositivo/EditarDispositivo";
import Compartir from "components/Dispositivo/CompartirDispositivos/CompartirDispositivo";
import Formulario from "components/Cliente/EditarCliente/Formulario";
import FormularioNuevoCliente from "components/Cliente/NuevoCliente/Step";
import NuevaAlerta from "components/Alertas/NuevaAlerta/NuevaAlerta";
import EditarAlerta from "components/Alertas/EditarAlerta/EditarAlerta";
import InfoContacto from "components/PantallaPolicial/InfoContacto";
import TablaAlertas from "components/PantallaPolicial/TablaNotificaciones";
import TablaAlertasUsuario from "components/PantallaPolicial/TablasUsuario/TablaNotificaciones";
import { SnackbarProvider, useSnackbar } from "notistack";
import Formulario1 from "components/Cliente/NuevoCliente/Formulario1";
import EditarGrupo from "components/Grupo/grupos/EditarGrupo";
import EditarSubGrupo from "components/Grupo/subgrupos/EditarSubGrupo";
import AgregarGrupo from "components/Grupo/grupos/AgregarGrupo";
import AgregarSubGrupo from "components/Grupo/subgrupos/AgregarSubGrupo";
import NuevoWidget from "components/widget/NuevoWidget";
import HelpPopover from "./HelpPopover";
import DescargoPolicial from "components/PantallaPolicial/DescargoPolicial/Descargo";
import Soporte from "components/Soporte";
////////Icono INFORMACION////////////////
import { Role } from "types/roles";

////////estilos///////////////

const useStyles = makeStyles((theme) => ({
  dialog: {
    minHeight: "200px",
    minWidth: "200px",
  },
  icono: {
    zIndex: 999,
    width: "99%",
    position: "absolute",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
}));
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    borderRadius: "10px",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(0),
    top: theme.spacing(0),
    color: theme.palette.grey[500],
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    height: "64px",
    width: "20%",
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const showHelp = props.children.props.help ? true : false;
  const helpData = showHelp ? props.children.props.help : null;
  const { help, titulo, children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle
      disableTypography
      className={classes.root}
      {...other}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <Typography variant="h6" style={{ width: "80%" }}>
        {children}
      </Typography>
      <div className={classes.closeButton}>
        {showHelp && <HelpPopover info={helpData} />}
        {onClose ? (
          <IconButton aria-label="close" onClick={onClose}>
            <MdClose />
          </IconButton>
        ) : null}
      </div>
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);
const DialogContentMap = withStyles((theme) => ({
  root: {
    width: "400px",
    height: "400px",
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);
export default function Dialogs(props) {
  const classes = useStyles();
  const [open, setOpenD] = React.useState(true);
  const handleCloseD = () => {
    setOpenD(false);
    props.handleClose();
  };
  const handleOpenD = () => {
    setOpenD(true);
  };
  return (
    <div>
      {(props.open === true && !(!props.option && props.content) ) ? (
        <>
          <Dialog
            disableBackdropClick
            className={classes.dialog}
            onClose={handleCloseD}
            open={props.open}
            aria-labelledby="customized-dialog-title"
            fullWidth={props.fullWidth ? props.fullWidth : false}
            maxWidth={props.maxWidth ? props.maxWidth : false}
          >
            <DialogTitle id="customized-dialog-title" onClose={handleCloseD}>
              <TituloDialogs titulo={props.titulo} help={props.help} />
            </DialogTitle>
            {props.option === "info" && (
              <DialogContent dividers>
                <InfoBody dispositivo={props.dispositivo}body={props.body} open={props.open} />
              </DialogContent>
            )}
            {props.option === "map" && (
              <DialogContentMap dividers>
                <MapInfo
                  open={props.open}
                  rowData={props.body}
                  center={[props.body.latitud, props.body.longitud]}
                  selected={[props.body.latitud, props.body.longitud]}
                  zoom={14}
                />
              </DialogContentMap>
            )}
            {props.option === "battery" && (
              <DialogContent dividers>
                <BatteryInfo rowData={props.body} />
              </DialogContent>
            )}
            {props.option === "nuevoUsuario" && (
              <DialogContent dividers>
                <FormNuevoUsuario refreshUs={props.refreshUs} />
              </DialogContent>
            )}
            {props.option === "editarUsuario" && (
              <DialogContent dividers>
                <ActualizarUsuario
                  onClose={handleCloseD}
                  user={props.user}
                  refreshUs={props.refreshUs}
                  clienteId={props.clienteId}
                ></ActualizarUsuario>
              </DialogContent>
            )}
            {props.option === "editarDispositivo" && (
              <DialogContent dividers>
                <EditarDispositivo
                  data={props.data}
                  update={props.update}
                  setOpen={props.setOpen}
                  refreshUs={props.refreshUs}
                />
              </DialogContent>
            )}
            {props.option === "compartirDispositivo" && (
              <DialogContent dividers>
                <Compartir data={props.data} update={props.update} />
              </DialogContent>
            )}
            {props.option === "nuevoCliente" && (
              <DialogContent dividers>
                <FormularioNuevoCliente
                  grabarCliente={props.grabarCliente}
                  errorCliente={props.errorCliente}
                  cliente={props.cliente}
                />
              </DialogContent>
            )}
            {props.option === "editarCliente" && (
              <DialogContent dividers>
                <Formulario
                  handleClose={props.handleClose}
                  grabarCliente={props.grabarCliente}
                  errorCliente={props.errorCliente}
                  cliente={props.cliente}
                  alerta={props.alerta}
                />
              </DialogContent>
            )}
            {props.option === "nuevaAlerta" && (
              <DialogContent dividers>
                <NuevaAlerta
                  setOpen={props.setOpen}
                  init={props.init}
                  update={props.update}
                  alerta={props.alerta}
                />
              </DialogContent>
            )}
            {props.option === "editarAlerta" && (
              <DialogContent dividers>
                <EditarAlerta
                  setOpen={props.setOpen}
                  init={props.init}
                  update={props.update}
                  elegido={props.elegido}
                  alerta={props.alerta}
                />
              </DialogContent>
            )}
            {props.option === "contactoAlerta" && (
              <DialogContent dividers>
                <InfoContacto cliente={props.cliente} />
              </DialogContent>
            )}
            {props.option === "infoAlerta" && (
              <SnackbarProvider maxSnack={3}>
                <DialogContent dividers>
                  {props.rol === Role.Supervisor ? (
                    <TablaAlertas
                      logs={props.logs}
                      refresh={props.refresh}
                      setCurrent={props.setCurrent}
                    />
                  ) : (
                    <TablaAlertasUsuario
                      logs={props.logs}
                      refresh={props.refresh}
                      setCurrent={props.setCurrent}
                    />
                  )}
                </DialogContent>
              </SnackbarProvider>
            )}
            {props.option === "formulario1" && (
              <DialogContent dividers>
                <Formulario1 />
              </DialogContent>
            )}
            {props.option === "nuevoGrupo" && (
              <DialogContent dividers>
                <AgregarGrupo
                  init={props.init}
                  setOpen={props.setOpen}
                  handleClose={props.handleClose}
                  clienteID={props.clienteID}
                  name={props.name}
                  alerta={props.alerta}
                />
              </DialogContent>
            )}
            {props.option === "editarGrupo" && (
              <DialogContent dividers>
                <EditarGrupo
                  init={props.init}
                  setOpen={props.setOpen}
                  handleClose={props.handleClose}
                  grupo={props.grupo}
                  name={props.name}
                  alerta={props.alerta}
                />
              </DialogContent>
            )}
            {props.option === "nuevoSubgrupo" && (
              <DialogContent dividers>
                <AgregarSubGrupo
                  desdeTabla={props.desdeTabla}
                  init={props.inits}
                  setOpen={props.setOpen}
                  clienteID={props.clienteID}
                  grupo={props.grupo}
                  nameSg={props.nameSg}
                  alerta={props.alerta}
                />
              </DialogContent>
            )}
            {props.option === "editarSubgrupo" && (
              <DialogContent dividers>
                <EditarSubGrupo
                  init={props.inits}
                  setOpen={props.setOpen}
                  grupo={props.grupo}
                  nameSg={props.nameSg}
                  alerta={props.alerta}
                />
              </DialogContent>
            )}
            {props.option === "nuevoWidget" && (
              <DialogContent dividers>
                <NuevoWidget handlerSelection={props.handlerSelection} />
              </DialogContent>
            )}
            {props.option === "descargo-policial" && (
              <DialogContent dividers>
                <DescargoPolicial
                  lista={props.lista}
                  rol={props.rol}
                  disable={props.disable}
                  index={props.index}
                  current={props.current}
                />
              </DialogContent>
            )}
            {props.option === "soporte" && (
              <DialogContent dividers>
                <Soporte
                  open={props.open}
                  handleClose={props.handleClose}
                  estado={props.estado}
                  funcion={props.funcion}
                />
              </DialogContent>
            )}
          </Dialog>
        </>
      ) :
        (props.open === true && !props.option && props.content) ?
        <Dialog
            disableBackdropClick
            className={classes.dialog}
            onClose={handleCloseD}
            open={props.open}
            aria-labelledby="customized-dialog-title"
            fullWidth={props.fullWidth ? props.fullWidth : false}
            maxWidth={props.maxWidth ? props.maxWidth : false}
          >
            <DialogTitle id="customized-dialog-title" onClose={handleCloseD}>
              <TituloDialogs titulo={props.titulo} help={props.help} />
            </DialogTitle>
          <DialogContent dividers>{props.content}</DialogContent>
        </Dialog>
        :
        null
      }
    </div>
  );
}
